import { memo } from 'react';
import PropTypes from 'prop-types';
import { MODAL_SIZES } from 'shared-modules/constants';
import { SYSTEM_NOTIFICATION_TYPES } from 'shared-modules/constants/core';
import { useSystemNotificationModalInfo } from 'shared-modules/hooks/system';
import { useMaintenanceMessages } from 'shared-modules/hooks/service';
import { useSemiBlockingModal } from 'shared-modules/hooks/modal';
import { Button, Modal } from '../../../../components';
import styles from './maintenanceModal.module.scss';

export const MaintenanceModal = memo(({ visible, isBlock, isBlocked, timestamp }) => {
  const { title, line1, line2, line3, line4, linkURL, buttonLabel } = useMaintenanceMessages();
  const { isOpen, onClose } = useSemiBlockingModal({
    visible,
    isBlock,
    isBlocked,
    timestamp,
    ready: true,
    disabled: false,
  });
  useSystemNotificationModalInfo({
    notificationType: SYSTEM_NOTIFICATION_TYPES.MAINTENANCE,
    visible: isOpen,
  });
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      size={MODAL_SIZES.WIDTH_400_600}
      isOutsideClickDontClose
      withoutCloseButton
      isOverlap
      isOverlayModal
    >
      <div className={styles.wrapper}>
        <div className={styles.errorMessage}>
          {line1}
          {line2}
          <a href={linkURL} className={styles.link}>
            {line3}
          </a>
          {line4}
        </div>
        <div className={styles.buttonsContainer}>
          {!isBlock && (
            <Button onClick={onClose} secondary>
              {buttonLabel}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
});

MaintenanceModal.propTypes = {
  visible: PropTypes.bool,
  isBlock: PropTypes.bool,
  isBlocked: PropTypes.bool,
  timestamp: PropTypes.number,
};

MaintenanceModal.defaultProps = {
  visible: false,
  isBlock: false,
  isBlocked: false,
  timestamp: undefined,
};
